import { Game } from '@/constants/game.const';

// Game enum may contain more games that we cover in code, but we don't
// support them in the app. We don't want to expose routes based on all of them,
// we define a subset of games that we support in the app.
export const supportedGames = [Game.DOTA, Game.CS2] as const;

export type SupportedGame = (typeof supportedGames)[number];

export function isSupportedGame(game: string): game is SupportedGame {
  return supportedGames.includes(game as SupportedGame);
}
